import { DetectBankIdRedirectOptions } from "../types";

// Determine whether the current page load is a BankID redirect.
export function detectBankIdRedirect({
  hash,
  nonceKeys,
  cleanupKeys = [],
  condition = true,
}: DetectBankIdRedirectOptions): boolean {
  const nonceMatch = hash.match(/[#&]nonce=([^&]+)/);
  if (!nonceMatch || !condition) return false;

  // Clean up localStorage keys left by the original tab
  const keys = Array.isArray(nonceKeys) ? nonceKeys : [nonceKeys];
  for (const key of [...keys, ...cleanupKeys]) {
    localStorage.removeItem(key);
  }

  return true;
}
